import { cn } from "@/lib/utils";

// Import 3D icons
import iconHospedagem from "@/assets/icons/icon-hospedagem.png";
import iconCreche from "@/assets/icons/icon-creche.png";
import iconPetsitter from "@/assets/icons/icon-petsitter.png";
import iconPasseio from "@/assets/icons/icon-passeio.png";
import iconVeterinario from "@/assets/icons/icon-veterinario.png";
import icontaxi_dog from "@/assets/icons/icon-taxi_dog.png";
import iconAdestramento from "@/assets/icons/icon-adestramento.png";
import iconAdocao from "@/assets/icons/icon-adocao.png";
import iconbanhoetosa from "@/assets/icons/icon-banhoetosa.png";

interface CategoryIconsProps {
  selected?: string;
  onSelect?: (category: string) => void;
}

const categories = [
  { id: "hospedagem", label: "Hospedagem", icon: iconHospedagem },
  { id: "creche", label: "Creche", icon: iconCreche },
  { id: "petsitter", label: "Pet Sitter", icon: iconPetsitter },
  { id: "passeio", label: "Passeio", icon: iconPasseio },
  { id: "veterinario", label: "Veterinário", icon: iconVeterinario },
  { id: "taxi_dog", label: "Táxi dog", icon: icontaxi_dog },
  { id: "banho_e_tosa", label: "Banho e Tosa", icon: iconbanhoetosa },
  { id: "adestramento", label: "Adestramento", icon: iconAdestramento },
  { id: "adocao", label: "Adoção", icon: iconAdocao },
];

export function CategoryIcons({ selected, onSelect }: CategoryIconsProps) {
  return (
    <div className="w-full overflow-x-auto scrollbar-hide">
      <div className="flex items-center gap-6 md:gap-10 py-4 min-w-max px-4 md:justify-center">
        {categories.map(({ id, label, icon }) => (
          <button
            key={id}
            onClick={() => {
                if (id === "adocao") {
                  window.location.href = "/adocao";
                  return;
                }

                onSelect?.(id);
              }}
            className={cn(
              "group flex flex-col items-center gap-2 pb-2 border-b-2 transition-all duration-300 min-w-[70px]",
              selected === id
                ? "border-forest"
                : "border-transparent hover:border-muted-foreground/50"
            )}
          >
            <div className={cn(
              "w-14 h-14 md:w-16 md:h-16 transition-all duration-300 ease-out",
              selected === id ? "scale-110" : "group-hover:scale-115 group-hover:-translate-y-1"
            )}>
              <img 
                src={icon} 
                alt={label} 
                className={cn(
                  "w-full h-full object-contain drop-shadow-md transition-all duration-300",
                  "group-hover:drop-shadow-lg group-hover:brightness-105"
                )}
              />
            </div>
            <span className={cn(
              "text-xs font-semibold whitespace-nowrap transition-colors duration-200",
              selected === id ? "text-forest" : "text-muted-foreground"
            )}>
              {label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
